
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum CrayonSubscriptionStatus {
	None = 0,
	Active = 1,
	Suspended = 2,
	Deleted = 4,
	CustomerCancellation = 8,
	Converted = 16,
	Inactive = 30,
	Expired = 32,
	Pending = 64,
	All = 31
}
export namespace CrayonSubscriptionStatus {
	export function getKeys(): Map<CrayonSubscriptionStatus, string> {
		return new Map([[0, 'None'], [1, 'Active'], [2, 'Suspended'], [4, 'Deleted'], [8, 'CustomerCancellation'], [16, 'Converted'], [30, 'Inactive'], [32, 'Expired'], [64, 'Pending'], [31, 'All']]);
	}
}
